import { DocumentType, Invoice, InvoiceItem, InvoiceItemType } from 'entities/Invoice';
import { Payment, PaymentItem } from 'entities/Payment';
import { User } from 'entities/User';
import { Warehouse } from 'entities/Warehouse';

export enum InvoiceCreditNoteType {
  DEBT_CREDIT = 'debt-credit',
  SERVICE_CREDIT = 'service-credit',
  IMPAIRMENT_DEBT_CREDIT = 'impairment-debt-credit',
}

export enum PersonalCreditNoteType {
  COMPENSATION = 'compensation',
  CUSTOMER_REFUND = 'customer-refund',
  BALANCE_REFUND = 'balance-refund',
}

export enum PaymentCreditNoteType {
  PAYMENT_CREDIT = 'payment-credit',
  PAYMENT_REVERSAL_CREDIT = 'payment-reversal-credit',
}

export type CreditNoteType = InvoiceCreditNoteType | PersonalCreditNoteType | PaymentCreditNoteType;
export interface CreditNote {
  creditNoteId: string;
  creditNoteType: CreditNoteType;
  creditNoteItems: CreditNoteItem[];
  user: User;
  warehouse: Warehouse;
  invoice?: Invoice;
  payment?: Payment;
  creditedAmount: number;
  currency: string;
  description?: string;
  issuedBy: Nullable<User>;
  documentNumber: string;
  documentType: DocumentType;
  createdAt: string;
}

export enum PersonalCreditNoteItemType {
  COMPENSATION = 'COMPENSATION',
  REFUND = 'REFUND',
  BALANCE = 'BALANCE',
  OTHER = 'Other',
}

export enum PaymentCreditNoteItemType {
  PAYMENT = 'PAYMENT',
}

export type CreditNoteItemType = InvoiceItemType | PersonalCreditNoteItemType | PaymentCreditNoteItemType;

export interface CreditNoteItem {
  creditNoteItemId: string;
  creditNote: CreditNote;
  creditNoteItemType: CreditNoteItemType;
  paymentItemId?: string;
  paymentItem?: PaymentItem;
  invoiceItem?: InvoiceItem;
  vatRatePercent: number;
  vatRateAmount: number;
  creditedAmount: number;
  extraAmount: number;
  dateFrom?: string;
  dateTo?: string;
  description?: string;
  createdAt: string;
}
